import React from "react";

/**
 * Brutalist 30-day launch heatmap. Six columns × five rows, latest day
 * bottom-right. Cells are thick-bordered squares; red intensity = launches
 * per day relative to the busiest day in view.
 */
export default function UsageHeatmap({ daily }) {
    if (!daily || daily.length === 0) return null;
    const max = Math.max(1, ...daily.map((d) => d.count));
    const intensity = (n) => {
        if (n === 0) return "bg-white";
        const r = n / max;
        if (r > 0.8) return "bg-[#E8241A] text-white";
        if (r > 0.5) return "bg-[#F56A62] text-black";
        if (r > 0.2) return "bg-[#FBBFBB] text-black";
        return "bg-[#FFE2E0] text-black";
    };
    // 30 days, 6 columns × 5 rows
    return (
        <div className="space-y-3" data-testid="usage-heatmap">
            <div className="grid grid-cols-6 gap-2">
                {daily.map((d) => (
                    <div
                        key={d.date}
                        className={[
                            "brut-border aspect-square flex flex-col items-center justify-center font-display text-xs sm:text-sm leading-none",
                            intensity(d.count),
                        ].join(" ")}
                        title={`${d.date} — ${d.count} launches`}
                        data-testid={`heatmap-cell-${d.date}`}
                    >
                        <span className="text-[10px] opacity-60">
                            {d.date.slice(5)}
                        </span>
                        <span className="mt-1">{d.count}</span>
                    </div>
                ))}
            </div>
            <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest">
                <span>Less</span>
                <span className="w-4 h-4 brut-border bg-white" />
                <span className="w-4 h-4 brut-border bg-[#FFE2E0]" />
                <span className="w-4 h-4 brut-border bg-[#FBBFBB]" />
                <span className="w-4 h-4 brut-border bg-[#F56A62]" />
                <span className="w-4 h-4 brut-border bg-[#E8241A]" />
                <span>More</span>
            </div>
        </div>
    );
}
